// Apibase.js
const prod = 'https://utilityaidportal.co.uk';
const dev = 'https://utilityaidfinance.co.uk/portal';

export const Apibase = process.env.NODE_ENV === 'development' ? dev : prod;
